/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import { cn } from '@discover-lib/utils';

export type LogButtonProps = Omit<
  React.ComponentPropsWithoutRef<'i'>,
  'onClick' | 'name' | 'data'
> & {
  name: string;
  data: unknown;
};

export default function LogButton({ name, data, className, ...props }: LogButtonProps) {
  return (
    <i
      className={cn('cursor-pointer not-italic leading-snug', className)}
      title="Log"
      // eslint-disable-next-line no-console
      onClick={() => console.log(name, data)}
      {...props}>
      🪵
    </i>
  );
}
